import mapDataUSA from '@highcharts/map-collection/countries/us/us-all.geo.json';
export const hideDistrictMap = [37,41,51,53,59,233,64,190,191,192,72,90,92];
export const DISTRIBUTION_CHART_OPTIONS = {
    chart: {
        type: 'bar',
        backgroundColor: '#F9FAFB'
    },
    colors: ['#AD509E'],
    title: { text: null },
    subtitle: { text: null },
    navigation: { buttonOptions: { enabled: false } },
    xAxis: {
        type: 'category',
        title: { text: null },
        lineColor: 'transparent',
        labels: {
            align: 'left',
            reserveSpace: true
        },
        scrollbar: { enabled: true }
    },
    yAxis: {
        labels: { enabled: false },
        title: { text: null },
        gridLineWidth: 0
    },
    plotOptions: {
        bar: {
            dataLabels: {
                enabled: true,
                x: 1
            }
        },
        series: {
            label: { enabled: false },
            states: { hover: { enabled: false } },
            borderRadius: 5,
            pointWidth: 8,
            groupPadding: 0,
            pointPadding: 0
        }
    },
    legend: { enabled: false },
    tooltip: { enabled: false },
    credits: { enabled: false },
    series: [
        {
            name: null,
            data: [
                ['North East', 79],
                ['South East', 49],
                ['Central', 48],
                ['West', 46],
                ['Central South', 22],
                ['Unassigned', 19]
            ]
        }
    ]
};

export const mapOptions = {
    chart: {
        backgroundColor: 'transparent',
        type: 'map',
        map: 'countries/us/us-all'
    },
    title: { text: null },
    credits: { enabled: false },
    mapNavigation: {
        enabled: false,
        enableButtons: false
    },
    navigation: { buttonOptions: { enabled: false } },
    credits: { enabled: false },
    tooltip: {
        //   headerFormat: "",
        //   pointFormat: "lat: {point.lat}, lon: {point.lon}",
        formatter: function () {
            return (
                '<b>' + this.point.options.keyword + '</b><br/>' + this.point.options.z
            );
        }
    },
    legend: { enabled: false },
    series: [
        {
            // Use the gb-all map with no data as a basemap
            name: 'US Map',
            mapData: mapDataUSA,
            borderColor: '#FFFFFF',
            nullColor: '#E4E7EC',
            showInLegend: false,
            states: {
                hover: {
                    color: null,
                    borderColor: null
                }
            }
        },
        {
            // Specify points using lat/lon
            type: 'mapbubble',
            name: 'Locations',
            states: {
                hover: {
                    color: null,
                    borderColor: null
                }
            },
            color: '#2E90FA',
            data: [
                // { z: 10, keyword: "Massachusetts", lat: 42.40, lon: -71.38},
                // { z: 20, keyword: "Washington", lat: 47.48, lon: -120.36},
                // { z: 30, keyword: "California", lat: 36.74, lon: -119.59},
                // { z: 40, keyword: "Oregon", lat: 43.83, lon: -120.38},
                {
                    z: 79, keyword: 'North East', lat: 43.29, lon: -74.21
                },
                {
                    z: 49, keyword: 'South East', lat: 63.96, lon: -143.62
                },
                {
                    z: 26, keyword: 'Mid West', lat: 37.93, lon: -90.17
                },
                {
                    z: 21, keyword: 'South West', lat: 32.31, lon: -110.92
                },
                {
                    z: 15, keyword: 'West Coast', lat: 47.75, lon: -121.09
                },
                {
                    z: 19, keyword: 'Unassiged', lat: null, lon: null
                }

            ],
            cursor: 'pointer',
            point: {
                events: {
                    click: function () {
                        console.log(this.keyword);
                    }
                }
            }
        }
    ]
};

export const USA_CHART_OPTIONS = {
    title: { text: null },
    chart: {
        backgroundColor: 'transparent',
        type: 'map',
        map: null
    },
    mapNavigation: {
        enabled: false,
        enableButtons: false
    },
    navigation: { buttonOptions: { enabled: false } },
    credits: { enabled: false },
    colorAxis: {
        min: 1,
        type: 'logarithmic',
        minColor: '#FAEDF9',
        maxColor: '#8C3F7D',
        stops: [
            [0, '#FAEDF9'],
            [0.67, '#DB97D2'],
            [1, '#8C3F7D']
        ]
    },
    tooltip: {
        formatter: function () {
            return '<b>' + this.point.name + '</b><br/>' + this.point.value;
        }
    },
    legend: {
        enabled: true,
        align: 'right',
        horizontalAlign: 'bottom',
        layout: 'horizontal',
        borderWidth: 0,
        margin: 0,
        x: -50,
        y: 0
    },
    series: [
        {
            name: 'us map',
            dataLabels: {
                enabled: true,
                color: '#000000',
                format: '{point.postal-code}',
                // align: 'center',
                shadow: false,
                backgroundColor: 'transparent',
                zIndex: 6,
                style: {
                    textTransform: 'uppercase',
                    fontWeight: 'normal',
                    fontStyle: 'normal',
                    textOutline: 'none'
                }
            },
            cursor: 'pointer',
            joinBy: 'postal-code'
        }
    ]
};
